export default __webpack_public_path__ + "static/media/photo2.5839dc2a.jpeg";